<svg
  *ngIf="name() === 'external-link'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M10 2H14V6" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.66675 9.33333L14.0001 2" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'activity'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 26 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M23.8334 10.0003H21.1467C20.6733 9.99955 20.2125 10.1181 19.835 10.3378C19.4574 10.5575 19.1837 10.8663 19.0559 11.217L16.5101 18.1837C16.4937 18.2269 16.4595 18.2649 16.4126 18.292C16.3657 18.319 16.3087 18.3337 16.2501 18.3337C16.1915 18.3337 16.1345 18.319 16.0876 18.292C16.0407 18.2649 16.0065 18.2269 15.9901 18.1837L10.0101 1.81699C9.99367 1.77372 9.95946 1.73571 9.91258 1.70866C9.8657 1.68161 9.80868 1.66699 9.75008 1.66699C9.69148 1.66699 9.63446 1.68161 9.58758 1.70866C9.5407 1.73571 9.50649 1.77372 9.49008 1.81699L6.94425 8.78366C6.81692 9.13295 6.54491 9.44076 6.16952 9.66034C5.79412 9.87992 5.33584 9.99929 4.86425 10.0003H2.16675" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'contribute'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M11.3334 4.66699L4.66675 11.3337" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.3334 11.3337H4.66675V4.66699" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'grant'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_5307_11702)">
    <path d="M9.6907 14.4577C9.71603 14.5208 9.76006 14.5747 9.81688 14.6121C9.87371 14.6494 9.9406 14.6685 10.0086 14.6668C10.0766 14.665 10.1424 14.6426 10.1973 14.6023C10.2521 14.5621 10.2933 14.506 10.3154 14.4417L14.6487 1.77503C14.67 1.71596 14.6741 1.65203 14.6604 1.59073C14.6468 1.52943 14.6159 1.47329 14.5715 1.42888C14.5271 1.38447 14.471 1.35363 14.4097 1.33996C14.3484 1.32629 14.2844 1.33036 14.2254 1.3517L1.5587 5.68503C1.49436 5.70709 1.43832 5.74831 1.39808 5.80314C1.35785 5.85798 1.33535 5.92381 1.33361 5.9918C1.33186 6.05979 1.35096 6.12669 1.38834 6.18351C1.42571 6.24034 1.47958 6.28437 1.5427 6.3097L6.82937 8.4297C6.99649 8.49661 7.14833 8.59667 7.27574 8.72385C7.40315 8.85103 7.50349 9.00269 7.5707 9.1697L9.6907 14.4577Z" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.5692 1.43164L7.27588 8.72431" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_5307_11702">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>

<svg
  *ngIf="name() === 'invest'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.fill]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M4.8 16C3.45185 16 2.31467 15.5372 1.38844 14.6116C0.462223 13.6859 -0.000592024 12.5487 5.68344e-07 11.2C5.68344e-07 10.637 0.0962969 10.0889 0.288889 9.55556C0.481482 9.02222 0.755556 8.54074 1.11111 8.11111L4.26667 4.31111L2.11111 0H13.8889L11.7333 4.31111L14.8889 8.11111C15.2444 8.54074 15.5185 9.02222 15.7111 9.55556C15.9037 10.0889 16 10.637 16 11.2C16 12.5481 15.5333 13.6853 14.6 14.6116C13.6667 15.5378 12.5333 16.0006 11.2 16H4.8ZM8 11.5556C7.51111 11.5556 7.09274 11.3816 6.74489 11.0338C6.39704 10.6859 6.22282 10.2673 6.22222 9.77778C6.22163 9.2883 6.39585 8.86993 6.74489 8.52267C7.09393 8.17541 7.5123 8.00119 8 8C8.4877 7.99882 8.90637 8.17304 9.256 8.52267C9.60563 8.8723 9.77956 9.29067 9.77778 9.77778C9.776 10.2649 9.60207 10.6836 9.256 11.0338C8.90993 11.384 8.49126 11.5579 8 11.5556ZM5.88889 3.55556H10.1111L11 1.77778H5L5.88889 3.55556ZM4.8 14.2222H11.2C12.0444 14.2222 12.7594 13.9298 13.3449 13.3449C13.9304 12.76 14.2228 12.045 14.2222 11.2C14.2222 10.8444 14.1591 10.5001 14.0329 10.1671C13.9067 9.83407 13.7327 9.53393 13.5111 9.26667L10.2444 5.33333H5.77778L2.48889 9.24444C2.26667 9.51111 2.09274 9.81482 1.96711 10.1556C1.84148 10.4963 1.77837 10.8444 1.77778 11.2C1.77778 12.0444 2.07052 12.7594 2.656 13.3449C3.24148 13.9304 3.95615 14.2228 4.8 14.2222Z"/>
</svg>

<svg
  *ngIf="name() === 'transfer'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M10.6667 2L13.3334 4.66667L10.6667 7.33333" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.3334 4.66699H2.66675" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.33341 14.0003L2.66675 11.3337L5.33341 8.66699" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.66675 11.333H13.3334" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'currency-conversion'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.67737 2.00631 11.2874 2.66082 12.4933 3.82667L14 5.33333" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.0001 2V5.33333H10.6667" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 8C14 9.5913 13.3679 11.1174 12.2426 12.2426C11.1174 13.3679 9.5913 14 8 14C6.32263 13.9937 4.71265 13.3392 3.50667 12.1733L2 10.6667" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.33333 10.667H2V14.0003" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'error'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M31.9999 58.6663C46.7275 58.6663 58.6666 46.7273 58.6666 31.9997C58.6666 17.2721 46.7275 5.33301 31.9999 5.33301C17.2723 5.33301 5.33325 17.2721 5.33325 31.9997C5.33325 46.7273 17.2723 58.6663 31.9999 58.6663Z" stroke-width="5.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M32 21.333V31.9997" stroke-width="5.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M32 42.667H32.0267" stroke-width="5.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'star'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.fill]="color()"
  viewBox="0 0 19 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M5.86178 14.3542L9.27428 12.2958L12.6868 14.3813L11.793 10.4813L14.7993 7.88125L10.8451 7.52917L9.27428 3.84583L7.70345 7.50208L3.74928 7.85417L6.75553 10.4813L5.86178 14.3542ZM9.27428 14.8417L4.77845 17.55C4.57984 17.6764 4.3722 17.7306 4.15553 17.7125C3.93887 17.6944 3.74928 17.6222 3.58678 17.4958C3.42428 17.3694 3.29789 17.2116 3.20762 17.0224C3.11734 16.8332 3.09928 16.6209 3.15345 16.3854L4.34512 11.2667L0.363865 7.82708C0.18331 7.66458 0.0706432 7.47933 0.0258654 7.27133C-0.0189123 7.06333 -0.00555129 6.86039 0.0659487 6.6625C0.137449 6.46461 0.245782 6.30211 0.390949 6.175C0.536115 6.04789 0.734726 5.96664 0.986782 5.93125L6.24095 5.47083L8.2722 0.65C8.36248 0.433333 8.50259 0.270833 8.69253 0.1625C8.88248 0.0541665 9.07639 0 9.27428 0C9.47217 0 9.66609 0.0541665 9.85603 0.1625C10.046 0.270833 10.1861 0.433333 10.2764 0.65L12.3076 5.47083L17.5618 5.93125C17.8146 5.96736 18.0132 6.04861 18.1576 6.175C18.3021 6.30139 18.4104 6.46389 18.4826 6.6625C18.5548 6.86111 18.5686 7.06442 18.5238 7.27242C18.479 7.48042 18.366 7.66531 18.1847 7.82708L14.2034 11.2667L15.3951 16.3854C15.4493 16.6201 15.4312 16.8325 15.341 17.0224C15.2507 17.2124 15.1243 17.3702 14.9618 17.4958C14.7993 17.6215 14.6097 17.6937 14.393 17.7125C14.1764 17.7313 13.9687 17.6771 13.7701 17.55L9.27428 14.8417Z"/>
</svg>

<svg
  *ngIf="name() === 'empty-document'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 48 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M30 4H12C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8V40C8 41.0609 8.42143 42.0783 9.17157 42.8284C9.92172 43.5786 10.9391 44 12 44H36C37.0609 44 38.0783 43.5786 38.8284 42.8284C39.5786 42.0783 40 41.0609 40 40V14L30 4Z" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M28 4V12C28 13.0609 28.4214 14.0783 29.1716 14.8284C29.9217 15.5786 30.9391 16 32 16H40" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M29 25L19 35" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M19 25L29 35" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'close'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 6 6"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M5.5 0.5L0.5 5.5M0.5 0.5L5.5 5.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'close-circle'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="12" fill="#96080B"/>
  <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>

<svg
  *ngIf="name() === 'sort'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M7 4v16M7 4L3.5 7.5M7 4l3.5 3.5M17 20V4M17 20l3.5-3.5M17 20l-3.5-3.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'filter'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M3 5h18l-7 8v6l-4 2v-8L3 5z" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'exclamation-outline'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.fill]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M3.66346 20.6315C2.51734 19.5245 1.60315 18.2004 0.974242 16.7363C0.345334 15.2723 0.0142989 13.6976 0.000453081 12.1043C-0.0133927 10.5109 0.290228 8.93077 0.893598 7.45601C1.49697 5.98125 2.38801 4.64143 3.51472 3.51472C4.64143 2.38801 5.98125 1.49697 7.45601 0.893598C8.93077 0.290228 10.5109 -0.0133927 12.1043 0.000453081C13.6976 0.0142989 15.2723 0.345334 16.7363 0.974242C18.2004 1.60315 19.5245 2.51734 20.6315 3.66346C22.8174 5.92668 24.0269 8.95791 23.9995 12.1043C23.9722 15.2506 22.7102 18.2604 20.4853 20.4853C18.2604 22.7102 15.2506 23.9722 12.1043 23.9995C8.95791 24.0269 5.92668 22.8174 3.66346 20.6315ZM18.9395 18.9395C20.7408 17.1381 21.7528 14.695 21.7528 12.1475C21.7528 9.59996 20.7408 7.15681 18.9395 5.35546C17.1381 3.55411 14.695 2.54212 12.1475 2.54212C9.59996 2.54212 7.15681 3.55411 5.35546 5.35546C3.55411 7.15681 2.54212 9.59996 2.54212 12.1475C2.54212 14.695 3.55411 17.1381 5.35546 18.9395C7.15681 20.7408 9.59996 21.7528 12.1475 21.7528C14.695 21.7528 17.1381 20.7408 18.9395 18.9395ZM10.9475 6.14746H13.3475V13.3475H10.9475V6.14746ZM10.9475 15.7475H13.3475V18.1475H10.9475V15.7475Z" fill="#96080B"/>
</svg>

<svg
  *ngIf="name() === 'chevron-down'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 10 7"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M0.395303 2.28L3.84864 5.73333C4.36864 6.25333 5.20864 6.25333 5.72864 5.73333L9.18197 2.28C10.022 1.44 9.42197 0 8.2353 0H1.32864C0.141969 0 -0.444697 1.44 0.395303 2.28Z"
    [attr.fill]="color()"
  />
</svg>

<svg
  *ngIf="name() === 'chevron-right'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style="transform: rotate(-90deg)">
  <path
    d="M4 6L8 10L12 6"
    [attr.stroke]="color()"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name() === 'chevron-left'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style="transform: rotate(90deg)">
  <path
    d="M4 6L8 10L12 6"
    [attr.stroke]="color()"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name() === 'required-asterisk'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12 6.66667H7.6L10.7333 9.8L9.8 10.7333L6.66667 7.6V12H5.33333V7.53333L2.2 10.6667L1.26667 9.73333L4.26667 6.66667H0V5.33333H4.4L1.26667 2.2L2.2 1.26667L5.33333 4.4V0H6.66667V4.26667L9.73333 1.2L10.6667 2.2L7.53333 5.33333H12V6.66667Z"
    fill="#96080B"
  />
</svg>

<svg
  *ngIf="name() === 'trash-outline'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 13.3333 14.6666"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M0.666667 3.33329H12.6667" [attr.stroke]="color()" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.334 3.33329V12.6666C11.334 13.3333 10.6673 14 10.0007 14H3.33398C2.66732 14 2.00065 13.3333 2.00065 12.6666V3.33329" [attr.stroke]="color()" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.00065 3.33333V2C4.00065 1.33333 4.66732 0.666667 5.33398 0.666667H8.00065C8.66732 0.666667 9.33398 1.33333 9.33398 2V3.33333" [attr.stroke]="color()" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.33268 6.66667V10.6667" [attr.stroke]="color()" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.00065 6.66667V10.6667" [attr.stroke]="color()" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'settings'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 21 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M8.70975 2.02583C9.88981 1.76693 11.1082 1.76631 12.2885 2.024C12.3677 2.56778 12.5626 3.08593 12.8589 3.54007C13.1551 3.99421 13.5451 4.3727 14 4.6475C14.4548 4.92255 14.9628 5.08686 15.4864 5.12828C16.01 5.16969 16.5358 5.08715 17.0249 4.88675C17.8283 5.82956 18.4369 6.93623 18.8125 8.13725C18.403 8.48073 18.0724 8.91626 17.8452 9.41162C17.6181 9.90698 17.5001 10.4495 17.5 10.9991C17.5 12.1577 18.0127 13.1908 18.8134 13.8628C18.4369 15.0629 17.8277 16.1687 17.024 17.1105C16.5351 16.9103 16.0094 16.8278 15.486 16.8692C14.9625 16.9106 14.4547 17.0748 14 17.3498C13.5455 17.6245 13.1558 18.0027 12.8597 18.4565C12.5636 18.9103 12.3687 19.428 12.2894 19.9714C11.1094 20.2309 9.89104 20.2322 8.71062 19.9751C8.6318 19.4311 8.43711 18.9126 8.14099 18.4581C7.84486 18.0037 7.4549 17.6248 7 17.3498C6.54516 17.0749 6.03711 16.9107 5.51349 16.8694C4.98987 16.8282 4.46409 16.9109 3.97513 17.1114C3.17173 16.1686 2.56311 15.0619 2.1875 13.8609C2.59701 13.5174 2.92758 13.0819 3.15476 12.5865C3.38195 12.0912 3.49993 11.5487 3.5 10.9991C3.5 9.84042 2.98637 8.80825 2.18575 8.13542C2.56232 6.93555 3.17152 5.83016 3.97513 4.88858C4.46429 5.0887 4.99017 5.17095 5.51379 5.12921C6.03742 5.08748 6.54536 4.92284 7 4.6475C7.45432 4.37269 7.84385 3.99439 8.1398 3.5406C8.43574 3.08681 8.63053 2.56912 8.70975 2.02583ZM10.5 13.75C11.1962 13.75 11.8639 13.4603 12.3562 12.9445C12.8484 12.4288 13.125 11.7293 13.125 11C13.125 10.2707 12.8484 9.57118 12.3562 9.05546C11.8639 8.53973 11.1962 8.25 10.5 8.25C9.80381 8.25 9.13613 8.53973 8.64384 9.05546C8.15156 9.57118 7.875 10.2707 7.875 11C7.875 11.7293 8.15156 12.4288 8.64384 12.9445C9.13613 13.4603 9.80381 13.75 10.5 13.75Z" [attr.fill]="color()"/>
</svg>

<svg
  *ngIf="name() === 'info-circle'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_info_circle)">
    <path d="M8.00065 14.6663C11.6825 14.6663 14.6673 11.6816 14.6673 7.99967C14.6673 4.31778 11.6825 1.33301 8.00065 1.33301C4.31875 1.33301 1.33398 4.31778 1.33398 7.99967C1.33398 11.6816 4.31875 14.6663 8.00065 14.6663Z" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 10.6667V8" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 5.33301H8.00667" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_info_circle">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>

<svg
  *ngIf="name() === 'search'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <circle cx="7" cy="7" r="5" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 14L10.7 10.7" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'circle-check'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M21.8011 10.0005C22.2578 12.2418 21.9323 14.5719 20.879 16.6023C19.8256 18.6326 18.108 20.2405 16.0126 21.1578C13.9172 22.0751 11.5707 22.2463 9.3644 21.6428C7.15807 21.0394 5.22529 19.6979 3.88838 17.8419C2.55146 15.9859 1.89122 13.7277 2.01776 11.4439C2.14431 9.16001 3.04998 6.98857 4.58375 5.29165C6.11752 3.59473 8.18668 2.47491 10.4462 2.11893C12.7056 1.76295 15.0189 2.19234 17.0001 3.33548" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 11L12 14L22 4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'arrow-left'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M8.00016 12.6663L3.3335 7.99967L8.00016 3.33301" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.6668 8H3.3335" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

<svg
  *ngIf="name() === 'trash'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
    [attr.fill]="color()"
  />
</svg>
<svg
  *ngIf="name() === 'edit'"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_edit)">
    <path
      d="M6.59221 1.26172H1.93111C1.57791 1.26172 1.23918 1.40202 0.989427 1.65177C0.739674 1.90152 0.599365 2.24026 0.599365 2.59346V11.9157C0.599365 12.2688 0.739674 12.6076 0.989427 12.8573C1.23918 13.1071 1.57791 13.2474 1.93111 13.2474H11.2533C11.6065 13.2474 11.9453 13.1071 12.195 12.8573C12.4447 12.6076 12.585 12.2688 12.585 11.9157V7.25456"
      [attr.stroke]="color()"
      stroke-width="1.19857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8371 1.01138C11.102 0.746475 11.4613 0.597656 11.8359 0.597656C12.2105 0.597656 12.5698 0.746475 12.8347 1.01138C13.0996 1.27628 13.2485 1.63556 13.2485 2.01019C13.2485 2.38481 13.0996 2.74409 12.8347 3.00899L6.83322 9.01113C6.67511 9.1691 6.47978 9.2848 6.26523 9.34745L4.35219 9.90678C4.29489 9.92348 4.23415 9.92444 4.17633 9.90965C4.11851 9.89487 4.06575 9.86475 4.02354 9.82256C3.98133 9.78037 3.95126 9.72755 3.93644 9.66978C3.92163 9.61193 3.92263 9.5512 3.93934 9.49391L4.49868 7.58086C4.56162 7.36648 4.67749 7.17139 4.83561 7.01354L10.8371 1.01138Z"
      [attr.stroke]="color()"
      stroke-width="1.19857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_edit">
      <rect width="13.8477" height="13.8477" fill="white" />
    </clipPath>
  </defs>
</svg>

<svg
  *ngIf="name() === 'clock'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 13 13"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_clock)">
    <path
      d="M6.494 1.08203C5.05879 1.08203 3.68236 1.65217 2.66751 2.66702C1.65266 3.68187 1.08252 5.0583 1.08252 6.49351C1.08252 7.92873 1.65266 9.30516 2.66751 10.32C3.68236 11.3349 5.05879 11.905 6.494 11.905C7.92922 11.905 9.30565 11.3349 10.3205 10.32C11.3353 9.30516 11.9055 7.92873 11.9055 6.49351C11.9055 5.0583 11.3353 3.68187 10.3205 2.66702C9.30565 1.65217 7.92922 1.08203 6.494 1.08203Z"
      stroke-width="1.11328"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.49414 3.24609V6.49317L8.65855 7.57584"
      stroke-width="1.11328"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_clock">
      <rect width="12.9883" height="12.9883" fill="white" />
    </clipPath>
  </defs>
</svg>

<svg
  *ngIf="name() === 'cancel'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="12" cy="12" r="9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M5.63604 5.63604L18.364 18.364"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name() === 'save'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6 4H16L20 8V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H6C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4Z"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <circle cx="12" cy="14" r="2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M14 4V8H8V4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>

<svg
  *ngIf="name() === 'menu'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M4 6H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M4 12H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M4 18H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>

<svg
  *ngIf="name() === 'wand'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M21.64 3.64L20.36 2.36C20.1339 2.13389 19.8273 2.00688 19.5075 2.00688C19.1877 2.00688 18.8811 2.13389 18.655 2.36L2.36 18.655C2.13389 18.8811 2.00688 19.1877 2.00688 19.5075C2.00688 19.8273 2.13389 20.1339 2.36 20.36L3.64 21.64C3.86611 21.8661 4.17273 21.9931 4.4925 21.9931C4.81227 21.9931 5.11889 21.8661 5.345 21.64L21.64 5.345C21.8661 5.11889 21.9931 4.81227 21.9931 4.4925C21.9931 4.17273 21.8661 3.86611 21.64 3.64Z"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path d="M14 7L17 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 6V10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M19 14V18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 2V4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M7 8H3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M21 16H17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11 3H9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>

<svg
  *ngIf="name() === 'check-square'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M9 11L12 14L22 4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name() === 'send'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M22 2L11 13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M22 2L15 22L11 13L2 9L22 2Z"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name() === 'lock'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="3"
    y="11"
    width="18"
    height="11"
    rx="2"
    ry="2"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name() === 'rocket'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4.5 16.5C3 17.76 2.5 21.5 2.5 21.5C2.5 21.5 6.24 21 7.5 19.5C8.21 18.66 8.2 17.37 7.41 16.59C7.03771 16.2343 6.54247 16.0362 6.02779 16.0388C5.51311 16.0414 5.0199 16.2445 4.65 16.6L4.5 16.5Z"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M12 15L9 12C9.53214 10.6194 10.2022 9.29607 11 8.05C12.1652 6.18699 13.7876 4.65305 15.713 3.59674C17.6384 2.54043 19.8027 1.99732 22 2C22 4.72 21.22 9.5 16 13C14.7369 13.8168 13.3939 14.5029 12 15Z"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M9 12H4C4 12 4.55 8.97 6 8C7.62 6.92 11 8 11 8"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M12 15V20C12 20 15.03 19.45 16 18C17.08 16.38 16 13 16 13"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name() === 'eye'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <circle cx="12" cy="12" r="3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>

<svg
  *ngIf="name() === 'list'"
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.stroke]="color()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M8 6H21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M8 12H21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M8 18H21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M3 6H3.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M3 12H3.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M3 18H3.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
